<template>
  <div class="top-bar d-flex justify-space-between align-center">
    <div class="d-flex align-center">
      <v-img
        v-if="!signingFromSubdomain"
        src="@/assets/img/closd_logo.svg"
        width="130"
      ></v-img>
    </div>

    <ClosdLangSelector v-if="withLangSelector" />
  </div>
</template>

<script>
import ClosdLangSelector from '@/common/ClosdLangSelector.vue'
import { navigatingOnAvailableSubdomain } from '@/common/utils/url'

export default {
  name: 'LoginTopbar',
  components: { ClosdLangSelector },
  props: {
    withLangSelector: {
      type: Boolean,
      default: true,
    },
  },
  data () {
    return {
      signingFromSubdomain: false,
    }
  },
  mounted () {
    this.signingFromSubdomain = navigatingOnAvailableSubdomain()
  },
}
</script>

<style scoped lang="scss">
.top-bar {
  height: 65px;
}
</style>
